export default "__VITE_ASSET__BJwc$tMk__"